import { VALIDATOR_PATTERNS } from 'src/app/helper/class/app-constant';
import { formBuilderData, tableColum, } from 'src/app/helper/interface/response';
export const LIST_COL_Payment: formBuilderData[] = [
  {
    colName: 'payments_id',
    title: 'Payment Id',
    readonly: true
  },
  {
    colName: 'patient_fk_id',
    title: 'Patient Id',
    type: 'AUTOCOMPLETE',
    apiTblName: 'patient',
    selectKeyName: 'patient_id',
    selectPrimaryKey: 'id',
    apiFunName: 'search',
    forceSelection: false,
    autoSearch: {
      titleKey: 'patientName',
      selectFieldKeys: ['patientName', 'patient_id', 'mobile_no']
    },
    validator: [{ name: 'required' }]
  },
  {
    colName: 'invoice_id',
    title: 'Invoice Id',
    type: 'AUTOCOMPLETE',
    selectPrimaryKey: 'invoice_id',
    selectKeyName: 'invoice_id',
    apiFunName: 'searchInvoice',
    forceSelection: false,
    autoSearch: {
      titleKey: 'invoice_id',
      selectFieldKeys: ['invoice_id', 'due_amount']
    },
    event: {
      name: 'change',
      isCallback: true
    },
    icon_append: {
      category: 'APPEND',
      icon: 'pi pi-plus',
      text: 'Add',
    },
    validator: [{ name: 'required' }]
  },
  {
    colName: 'type',
    title: 'payment type ',
    type: 'select',
    apiTblName: 'payment_type',
    selectPrimaryKey: 'id',
    selectKeyName: 'payment_typeName',
    validator: [{ name: 'required' }]

  },

  {
    colName: 'amount',
    title: 'Amount',
    colType: 'CURRENCY',
    validator: [{ name: 'pattern', funValue: VALIDATOR_PATTERNS.NUMBER_FLOAT }],
  },
  // {
  //   colName: 'status',
  //   title: 'Status',
  //   type: 'select',
  //   selectPrimaryKey: 'id',
  //   selectKeyName: 'label',
  //   data: [{ label: 'Paid', id: 1 }, { label: 'Un paid', id: 2 }]
  // },
  {
    colName: 'payment_date',
    title: '  Date',
    filter: true,
    type: 'DATE',
    filterCol: { type: 'DATE' },
    colType: 'DATE',
    validator: [{ name: 'required' }]
  },
  { colName: 'payments_des', title: 'Description', type: 'TEXTAREA' },

];

export const PAYMENT_INFO: formBuilderData[] = [
  {
    colName: 'payments_id',
    title: 'Payment Id'
  },
  {
    colName: 'patient_id',
    title: 'Patient Id'
  },
  {
    colName: 'invoice_id',
    title: 'Invoice Id'
  },
  {
    colName: 'payment_typeName',
    title: 'Payment Mode'
  },
  {
    colName: 'amount',
    title: 'Amount'
  },
  {
    colName: 'payment_date',
    title: 'Payment Date',
    type: 'DATE'
  },
  {
    colName: 'payments_des',
    title: 'Description'
  },
  {
    colName: 'created_byName',
    title: 'Created By'
  },
  {
    colName: 'Paymentstatus',
    title: 'Status'
  },
]

export const PRESCRIPTION_MEDICINE: tableColum[] = [
  {
    colName: 'medicine',
    title: 'Medicine'
  },
  {
    colName: 'm_type',
    title: 'Medicine type'
  },
  {
    colName: 'dosage',
    title: 'Dosage'
  },
  {
    colName: 'frequency',
    title: 'Frequency'
  },
  {
    colName: 'duration',
    title: 'Duration'
  },
  {
    colName: 'notes',
    title: 'Notes'
  },
]

export const PRESCRIPTION_INFO: formBuilderData[] = [
  {
    colName: 'prescription_notes',
    title: 'Prescription Notes',
  },
  {
    colName: 'doctorName',
    title: 'Doctor Name'
  },
  {
    colName: 'visits_on',
    title: 'Visited On',
  },
]

export const PAYMENT_LIST: formBuilderData[] = [
  {
    colName: 'payments_id',
    title: 'Payment Id',
  },
  {
    colName: 'patient_id',
    title: 'Patient Id',
  },
  {
    colName: 'patientName',
    title: 'Patient Name',
  },
  {
    colName: 'invoice_id',
    title: 'Invoice Id',
  },
  {
    colName: 'type',
    title: 'payment type ',
    type: 'select',
    apiTblName: 'payment_type',
    selectPrimaryKey: 'id',
    selectKeyName: 'payment_typeName',
  },
  {
    colName: 'amount',
    title: 'Amount',
    colType: 'CURRENCY',
  },
  {
    colName: 'Paymentstatus',
    title: 'Status',
    colType: 'DROPDOWN',
    // filter: true,
    // sort: true,
    filterCol: {
      type: 'DROPDOWN',
      data: [{ key: 'Pending', label: 'Pending', color: 'warning' },
      { key: 'Paid', label: 'Paid', color: 'success' }]
    }
  },
  {
    colName: 'payment_date',
    title: '  Date',
    colType: 'DATE',
    filter: true,
    filterCol: { type: 'DATE' },
  },
]